import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/helpers/authHelper'
import { i18n } from '@/plugins/i18n'
import auth from '@/views/Auth/routes'
import documents from '@/views/Documents/routes'
import categories from '@/views/Categories/routes'
import suppliers from '@/views/Suppliers/routes'
import procurements from '@/views/Procurements/routes'
import userManagement from '@/views/UserManagement/routes'
import budgets from '@/views/Budgets/routes'
import affiliate from '@/views/Affiliate/routes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
    meta: {
      guest: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home/Pages/Home.vue'),
    meta: {
      layout: 'content',
      auth: true,
      title: i18n.t('Home'),
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/Profile/Pages/Profile.vue'),
    meta: {
      layout: 'content',
      auth: true,
      title: i18n.t('Profile'),
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/PaymentPage.vue'),
    meta: {
      layout: 'blank',
      auth: true,
      title: 'Payment',
    },
  },
  ...auth,
  ...documents,
  ...affiliate,
  ...categories,
  ...suppliers,
  ...procurements,
  ...userManagement,
  ...budgets,
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      auth: false,
      title: 'Error 404',
    },
  },
  {
    path: '*',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'blank',
      auth: false,
      title: 'Error 404',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.guest)) {
    if (isLoggedIn()) {
      next({ name: 'home' })
    }
  }
  next()
})

router.beforeResolve((to, from, next) => {
  if (typeof to.meta.roles !== 'undefined') {
    if (!Vue.prototype.$acl.hasRole(to.meta.roles)) {
      return next({ name: 'home' })
    }
  }

  return next()
})

router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME}`
  })
})

export default router
